<template>
  <div class="text-center py-16 px-4">
    <div
      class="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5"
      :class="iconBgClass"
    >
      <component
        v-if="icon"
        :is="icon"
        class="h-7 w-7"
        :class="iconColorClass"
      />
    </div>

    <h3 class="text-lg font-semibold text-surface-800 dark:text-surface-200 mb-2">
      {{ title }}
    </h3>

    <p class="text-sm text-surface-500 dark:text-surface-500 max-w-sm mx-auto mb-6 leading-relaxed">
      {{ message }}
    </p>

    <div v-if="$slots.actions" class="flex items-center justify-center gap-3">
      <slot name="actions"></slot>
    </div>

    <BaseButton
      v-else-if="actionText"
      :variant="actionVariant"
      :icon="actionIcon"
      @click="$emit('action')"
    >
      {{ actionText }}
    </BaseButton>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BaseButton from './BaseButton.vue'

const props = defineProps({
  icon: { type: Object, default: null },
  title: { type: String, default: 'No data available' },
  message: { type: String, default: 'There is no data to display at the moment' },
  actionText: { type: String, default: '' },
  actionIcon: { type: Object, default: null },
  actionVariant: { type: String, default: 'primary' },
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'info', 'warning', 'success'].includes(value)
  }
})

defineEmits(['action'])

const iconBgClass = computed(() => {
  const variants = {
    default: 'bg-surface-100 dark:bg-surface-800/60',
    info: 'bg-blue-50 dark:bg-blue-500/10',
    warning: 'bg-amber-50 dark:bg-amber-500/10',
    success: 'bg-accent-50 dark:bg-accent-500/10'
  }
  return variants[props.variant]
})

const iconColorClass = computed(() => {
  const variants = {
    default: 'text-surface-400 dark:text-surface-600',
    info: 'text-blue-500 dark:text-blue-400',
    warning: 'text-amber-500 dark:text-amber-400',
    success: 'text-accent-500 dark:text-accent-400'
  }
  return variants[props.variant]
})
</script>
